<!-- ORGANISM: AppBarExtensions.vue -->

<script setup lang="ts">
//
// Imports
//

// Vuetify
import { useDisplay } from "vuetify/lib/composables/display.mjs";

// Components
import AboutExtension from "../molecules/AboutExtension.vue";
import DevStatesExtension from "../molecules/DevStatesExtension.vue";

//
// Composables
//

// Breakpoints
const { smAndDown } = useDisplay();

// App Bar
const { extensionsConfig } = useAppBar();
</script>

<template>
  <div class="ma-4 w-100">
    <!-- About Extension -->
    <about-extension v-if="extensionsConfig.component === 'AboutExtension'" />

    <!-- Dev States Extension -->
    <dev-states-extension v-else-if="extensionsConfig.component === 'DevStatesExtension'" />
  </div>
</template>
